<template>
  <b-row>
    <b-col
      v-if="isExternalLabel"
      sm="6"
      md="4"
      lg="2"
      xl="1"
    >
      <b-form-group>
        <div class="form-label">
          <label :class="{ requiredlabel: (showErrors && !subrequest.isLabelValid) }">
            {{ $t('component.studyRequest.subRequestForm.subrequestNumber') }}
          </label>
        </div>
        <vt-input
          v-model="subrequest.label"
          v-validate="'required'"
          class="form-control-sm"
          qa="subrequest-form-label-input"
          :disabled="disabled"
          :class="{ requiredform: (showErrors && !subrequest.isLabelValid) }"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm="6"
      md="4"
      lg="3"
      xl="2"
      :class="{'col-lg-4':!isExternalLabel}"
    >
      <b-form-group>
        <div class="form-label">
          <label :class="{ requiredlabel: (showErrors && !subrequest.topographicCode) }">
            {{ $t('component.studyRequest.subRequestForm.topographicCode') }} *
            <vt-clone-toggle
              id="subRequestFormTopographicCodeClone"
              v-model="internalSelectedFields"
              qa="subrequest-form-label-clone"
              field="topographicCode"
            />
          </label>
        </div>
        <vt-combo-select
          v-model="subrequest.topographicCode"
          v-validate="'required'"
          class="nowrap"
          track-by="id"
          qa="subrequest-form-topographic-code-select"
          :options="topographicCodes"
          label="description"
          :class="{ requiredform: (showErrors && !subrequest.topographicCode) }"
          open-direction="top"
          :disabled="disabled || !laboratoryId"
          @input="selectTopographicCode"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm="6"
      md="4"
      lg="3"
      xl="3"
      :class="{'col-lg-4':!isExternalLabel}"
    >
      <b-form-group>
        <div class="form-label">
          <label :class="{ requiredlabel: (showErrors && !subrequest.sampleType) }">
            {{ $t('component.studyRequest.subRequestForm.sampleType') }} *
            <vt-clone-toggle
              id="subRequestFormsampleTypeClone"
              v-model="internalSelectedFields"
              qa="subrequest-form-sample-type-clone"
              field="sampleType"
            />
          </label>
        </div>
        <vt-combo-select
          v-model="subrequest.sampleType"
          v-validate="'required'"
          track-by="id"
          class="nowrap"
          qa="subrequest-form-sample-type-select"
          :options="sampleTypes"
          label="description"
          :class="{ requiredform: (showErrors && !subrequest.sampleType) }"
          open-direction="top"
          :disabled="disabled || !laboratoryId"
          @open="filterCurrentCaseTypes()"
          @input="selectSampleType"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm="6"
      md="4"
      lg="4"
      xl="3"
    >
      <b-form-group>
        <div class="form-label">
          <label>
            {{ $t('component.studyRequest.subRequestForm.procedure') }}
            <vt-clone-toggle
              id="subRequestFormProcedure"
              v-model="internalSelectedFields"
              qa="subrequest-form-procedure-clone"
              field="procedure"
            />
          </label>
        </div>
        <vt-combo-select
          v-model="subrequest.procedure"
          class="nowrap"
          track-by="id"
          qa="subrequest-form-procedure-select"
          :options="procedures"
          label="description"
          open-direction="top"
          :disabled="disabled"
          @input="$emit('loadCustomForm')"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="5"
      lg="4"
      xl
      :class="{'col-sm-6': !isExternalLabel, 'col-md-6': isExternalLabel}"
    >
      <b-form-group>
        <div class="form-label">
          <label>
            {{ $t('registry.sampleGrid.mostLikelyDiagnosis') }}
            <vt-clone-toggle
              id="subRequestFormMostLikelyDiagnosis"
              v-model="internalSelectedFields"
              qa="subrequest-form-most-likely-clone"
              field="mostLikelyMorphologicCode"
            />
          </label>
        </div>
        <vt-combo-select
          v-model="subrequest.mostLikelyMorphologicCode"
          track-by="id"
          qa="subrequest-form-most-likely-select"
          :options="mostLikelyMorphologicCodes"
          label="description"
          open-direction="top"
          :disabled="disabled"
          @input="$emit('loadCustomForm')"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm="3"
      md="2"
      lg="2"
      xl="2"
    >
      <b-form-group>
        <div class="form-label">
          <label>
            {{ $t('component.samplesModal.frag') }}
            <vt-clone-toggle
              id="subRequestFormFrag"
              v-model="internalSelectedFields"
              qa="subrequest-form-fragments-clone"
              field="surFragments"
            />
          </label>
        </div>
        <vt-input
          id="subRequestFormNFragments"
          v-model="subrequest.surFragments"
          qa="subrequest-form-fragments-input"
          :disabled="disabled"
          name="subRequestFormFrag"
          type="number"
          class="form-control-sm"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm="5"
      lg="3"
      xl="2"
      :class="{'col-md-4': isExternalLabel, 'col-md-5': !isExternalLabel}"
    >
      <b-form-group>
        <div class="form-label">
          <label>
            {{ $t('component.samplesModal.media') }}
            <vt-clone-toggle
              id="subRequestFormMedia"
              v-model="internalSelectedFields"
              qa="subrequest-form-conservation-clone"
              field="surConservation"
            />
          </label>
        </div>
        <vt-input
          id="subRequestFormObservations"
          v-model="subrequest.surConservation"
          qa="subrequest-form-conservation-input"
          :disabled="disabled"
          name="subRequestFormMedia"
          class="form-control-sm"
        />
      </b-form-group>
    </b-col>
    <b-col
      sm
      md="4"
      lg="3"
      xl="2"
    >
      <b-form-group>
        <div class="form-label">
          <label>
            {{ $t('component.samplesModal.date') }}
            <vt-clone-toggle
              id="subRequestFormSamplingDate"
              v-model="internalSelectedFields"
              qa="subrequest-form-sampling-clone"
              field="surSamplingDate"
            />
          </label>
        </div>
        <vt-date-picker
          qa="subrequest-form-sampling-date"
          :disabled="disabled"
          :model="subrequest.surSamplingDate"
          :not-after="new Date()"
          @update="subrequest.surSamplingDate = $event"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="12"
      class="mb-2"
      :class="{'col-xl':isExternalLabel, 'col-xl-8': !isExternalLabel}"
    >
      <div class="form-label">
        <label>
          {{ $t('global.observations') }}
          <vt-clone-toggle
            id="subRequestFormObservations"
            v-model="internalSelectedFields"
            qa="subrequest-form-observations-clone"
            field="observations"
          />
        </label>
      </div>
      <b-form-textarea
        v-model="observations"
        qa="subrequest-form-observations-input"
        :disabled="disabled"
        class="text-box"
        :rows="2"
        :max-rows="2"
      />
    </b-col>
  </b-row>
</template>
<script>
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { intersection } from 'lodash'
export default {
    name: 'SubRequestForm',
    props: {
        subrequest: { type: Object, required: true },
        laboratoryId: { type: Number, required: true },
        showErrors: { type: Boolean, required: true },
        disabled: { type: Boolean, default: false },
        selectedSampleTypes: { type: Array, required: true },
        isExternalLabel: { type: Boolean, default: false }
    },
    data() {
        return {
            selectedFields: [],
            disabledMockup: false,
            mostLikelyMorphologicCodes: [],
            sampleTypes: [],
            topographicCodes: [],
            procedures: []
        }
    },
    computed: {
        observations: {
            get() {
                return this.subrequest.surObservations ? this.subrequest.surObservations.text : ''
            },
            set(newValue) {
                if (this.subrequest.surObservations) {
                    this.subrequest.surObservations.text = newValue
                } else {
                    this.subrequest.surObservations = {
                        text: newValue
                    }
                }
            }
        },
        internalSelectedFields: {
            get() {
                return this.selectedFields.slice()
            },
            set(newValue) {
                this.selectedFields = newValue
            }
        }
    },
    created() {
        this.loadMostLikelyMorphologicCodes()
        this.loadProcedures()
        this.loadLaboratoriesCombos()
    },
    methods: {
        selectTopographicCode() {
            /* TODO: averiguar por que hace falta el forceupdate */
            this.$forceUpdate()
            this.$emit('loadCustomForm')
        },
        selectSampleType(sampleType) {
            this.$forceUpdate()
            this.$emit('changedSampleType', { newSampleType: sampleType, oldSampleTypeId: this.subrequest.sampleTypeId })
            this.$emit('loadCustomForm')
        },
        async loadTopographicCodes(laboratoryId) {
            if (laboratoryId) {
                this.topographicCodes = await commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory({ laboratoryId })
            }
        },
        filterCurrentCaseTypes() {
            const groupedCaseTypes = this.selectedSampleTypes
                .map(sampleType => sampleType.caseTypes)
                .map(caseTypes => {
                    return caseTypes.map(caseType => {
                        return caseType.id
                    })
                })
            let commonCaseTypeIds
            if (!groupedCaseTypes.length) {
                commonCaseTypeIds = null
            } else if (groupedCaseTypes.length === 1) {
                commonCaseTypeIds = groupedCaseTypes[0]
            } else {
                commonCaseTypeIds = intersection(...groupedCaseTypes)
            }
            this.loadSampleTypes(commonCaseTypeIds)
        },
        async loadSampleTypes(caseTypeIds) {
            this.sampleTypes = await commonSampleClassificationService.getCommonSampleTypeWithCaseTypesSampleClassificationsByLaboratory(
                {
                    laboratoryId: this.laboratoryId,
                    caseTypeIds: [caseTypeIds]
                }
            )
            this.$forceUpdate()
        },
        async loadMostLikelyMorphologicCodes() {
            this.mostLikelyMorphologicCodes = await commonSampleClassificationService.getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },
        async loadProcedures() {
            this.procedures = await commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },
        async loadLaboratoriesCombos() {
            if (this.laboratoryId) {
                await Promise.all([
                    this.loadTopographicCodes(this.laboratoryId)
                ])
            }
        }
    }
}
</script>

<style scoped>

</style>
